/* Secret Maddy theme helpers. Kept tiny on purpose: Dawn's own JS stays untouched. */
(function () {
  /* Collection grid density toggle (3 / 4 / 5 per row). Persists per browser. */
  function applyCols(v) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    grid.style.setProperty('--sm-cols', v);
    document.querySelectorAll('[data-sm-cols]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-sm-cols') === v);
    });
  }
  /* The toggle is rendered after Dawn's facets form; move it inside the form, right before the sort select,
     so the bar reads: filters | density | sort. Re-run after Dawn re-renders the facets. */
  function placeDensity() {
    var d = document.querySelector('.sm-density');
    var sort = document.querySelector('.facets__form .facet-filters.sorting');
    if (d && sort && d.nextElementSibling !== sort) sort.parentNode.insertBefore(d, sort);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sm-cols]');
    if (!b) return;
    var v = b.getAttribute('data-sm-cols');
    applyCols(v);
    try { localStorage.setItem('sm-cols', v); } catch (err) {}
  });
  /* Native <select> sizes to its longest option, which parks the chevron far from a short label like "Featured".
     Measure the selected label with the select's own font and size the box to it (chevron space = right padding). */
  function fitSort() {
    document.querySelectorAll('.facets-wrapper .facet-filters__sort').forEach(function (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      var cs = getComputedStyle(sel);
      var m = document.createElement('span');
      m.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;font:' + cs.font + ';letter-spacing:' + cs.letterSpacing + ';text-transform:' + cs.textTransform;
      m.textContent = opt.textContent.trim();
      document.body.appendChild(m);
      var w = m.getBoundingClientRect().width;
      m.remove();
      sel.style.width = Math.ceil(w + parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) + 4) + 'px';
    });
  }
  document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('.facet-filters__sort')) fitSort(); });
  function init() {
    placeDensity();
    fitSort();
    /* only honour a remembered density when the toggle is actually on the page (it is switched off by default) */
    try { var v = localStorage.getItem('sm-cols'); if (v && document.querySelector('[data-sm-cols]')) applyCols(v); } catch (err) {}
    var wrap = document.getElementById('main-collection-filters');
    if (wrap && window.MutationObserver) new MutationObserver(function () { placeDensity(); fitSort(); }).observe(wrap, { childList: true, subtree: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSort);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
